import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export default makeStyles((theme: Theme) => ({
  center: {
    textAlign: 'center',
    paddingTop: '8px'
  },
  actionLink: {
    paddingLeft: '8px',
    textDecoration: 'underline',
    color: theme.palette.infoText.main
  },
  question: {
    color: theme.palette.grey[400],
  }
}))
